import gql from "graphql-tag"

export const DELETE_BONUS_CONFIG = gql`
  mutation deleteBonusConfig($id: ID!) {
    deleteBonusConfig(id: $id) {
      status
    }
  }
`
